import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  Insurance,
  PrestationLock,
  UNVERIFIED_LOCK,
} from '@pulpo/pulpo-models';
import ApiService from '../api.service.abstract';
import { APP_CONFIG } from '@pulpo/app-config';
import { RouteReuseStrategy } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InsuranceService extends ApiService<Insurance> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient,
    routeReuse: RouteReuseStrategy
  ) {
    super(environment, http, 'insurance/api/insurances', routeReuse);
    if (environment.name === 'localDev') {
      this.url = 'http://localhost:8084';
    }
  }

  /** The product locking the insurance once imported into a trip, null when it is editable. */
  findLock(id: string): Observable<PrestationLock | null> {
    return this.http
      .get<PrestationLock | null>(`${this.url}/${this.endpoint}/${id}/lock`)
      .pipe(catchError(() => of(UNVERIFIED_LOCK)));
  }
}
